import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Modal from '../../../Shared/Modal';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  modal: {
    width: '100%',
    maxWidth: 1000,
    padding: '0 40px 40px 40px',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 1000,
  },
  modalSecondTitle: {
    paddingBottom: theme.spacing(2),
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down(1000)]: {
      padding: theme.spacing(0),
    },
  },
  italic: {
    fontStyle: 'italic',
  },
  bold: {
    fontWeight: 600,
  },
  blueText: {
    color: '#172b4d',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  blackText: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  text: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  row: {
    display: 'flex',
    alignItems: 'baseline',
  },
  listItem: {
    margin: 5,
  },
  list: {
    margin: 0,
  },
  decimalList: {
    listStyleType: 'decimal',
  },
}));

const AllergyBaselineAssessmentReport = ({
  showHelpPopup,
  setShowHelpPopup,
}) => {
  const classes = useStyles();
  const { en: { allergyBaselineAssessmentReport } } = useSelector((state) => state.i18n);

  return (
    <Modal
      open={showHelpPopup}
      handleClose={() => {
        setShowHelpPopup(false);
      }}
      classes={{ paper: classes.modal, container: classes.modalContainer }}
      title={allergyBaselineAssessmentReport.title}
      secondTitleStyle={classes.modalSecondTitle}
    >
      <div className={cx(classes.blackText, classes.bold)}>
        {allergyBaselineAssessmentReport.firstPart}
      </div>
      <div className={cx(classes.blackText)}>
        {allergyBaselineAssessmentReport.requirementsFirst}
      </div>
      <div className={cx(classes.blackText)}>
        {allergyBaselineAssessmentReport.requirementsSecond}
      </div>
      <div className={cx(classes.blackText, classes.italic)}>
        {allergyBaselineAssessmentReport.requirementsThird}
      </div>
      <div className={cx(classes.blackText, classes.italic)}>
        {allergyBaselineAssessmentReport.requirementsForth}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.QHSLabAllergyAssessmentTitle}
      </div>
      <div>
        {allergyBaselineAssessmentReport.QHSLabAllergyAssessmentText}
      </div>

      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.respiratoryAllergyPredictionTestTitle}
      </div>
      <div>
        {allergyBaselineAssessmentReport.respiratoryAllergyPredictionTestText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.generalAllergyHistoryTitle}
      </div>
      <div>
        {allergyBaselineAssessmentReport.generalAllergyHistoryText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.patientReportedAllergySymptomsTitle}
      </div>
      <div>
        {allergyBaselineAssessmentReport.patientReportedAllergySymptomsText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.sinoNasalOutcomeTestTitle}
      </div>
      <div>
        {allergyBaselineAssessmentReport.sinoNasalOutcomeTestText1}
      </div>
      <div className={cx(classes.text)}>
        {allergyBaselineAssessmentReport.sinoNasalOutcomeTestText2}
      </div>
      <ul className={classes.list}>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {allergyBaselineAssessmentReport.sinoNasalOutcomeTestMildTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {allergyBaselineAssessmentReport.sinoNasalOutcomeTestMildText}
            </p>
          </div>
        </li>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {allergyBaselineAssessmentReport.sinoNasalOutcomeTestModerateTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {allergyBaselineAssessmentReport.sinoNasalOutcomeTestModerateText}
            </p>
          </div>
        </li>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {allergyBaselineAssessmentReport.sinoNasalOutcomeTestSevereTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {allergyBaselineAssessmentReport.sinoNasalOutcomeTestSevereText}
            </p>
          </div>
        </li>
      </ul>
      <div className={cx(classes.text)}>
        {allergyBaselineAssessmentReport.sinoNasalOutcomeTestText3}
      </div>

      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.asthmaControlTestTitle}
      </div>
      <div>{allergyBaselineAssessmentReport.asthmaControlTestText}</div>
      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.allergyMedicationUseTitle}
      </div>
      <div>{allergyBaselineAssessmentReport.allergyMedicationUseText}</div>
      <div className={cx(classes.blueText, classes.bold)}>
        {allergyBaselineAssessmentReport.healthBehaviorsTitle}
      </div>
      <div>{allergyBaselineAssessmentReport.healthBehaviorsTextFirst}</div>
      <div className={cx(classes.text)}>
        {allergyBaselineAssessmentReport.healthBehaviorsTextSecond}
      </div>
      <div className={cx(classes.text)}>
        {allergyBaselineAssessmentReport.healthBehaviorsTextThird}
      </div>
      <div className={cx(classes.text)}>
        {allergyBaselineAssessmentReport.healthBehaviorsTextForth}
      </div>
      <div className={cx(classes.text, classes.bold)}>
        {allergyBaselineAssessmentReport.referencesTitle}
      </div>
      <ul className={cx(classes.decimalList, classes.list)}>
        <li>{allergyBaselineAssessmentReport.referencesFirst}</li>
        <li>{allergyBaselineAssessmentReport.referencesSecond}</li>
        <li>{allergyBaselineAssessmentReport.referencesThird}</li>
        <li>{allergyBaselineAssessmentReport.referencesFourth}</li>
        <li>{allergyBaselineAssessmentReport.referencesFifth}</li>
        <li>{allergyBaselineAssessmentReport.referencesSixth}</li>
      </ul>
    </Modal>
  );
};

AllergyBaselineAssessmentReport.propTypes = {
  showHelpPopup: PropTypes.bool.isRequired,
  setShowHelpPopup: PropTypes.func.isRequired,
};

export default AllergyBaselineAssessmentReport;
